import {
  LOAD_EMPLOYER_ANALYTICS,
  LOAD_AGENCY_PERFORMANCE,
  LOAD_JOB_PERFORMANCE,
  LOAD_JOB_PERFORMANCE_ERROR,
  LOAD_PSL_PERFORMANCE,
  LOAD_PSL_PERFORMANCE_ERROR,
  EMPLOYER_ANALYTICS_FILTER,
  RESET_DATE_RANGE_FILTER,
  RESET_PAGINATION_FLAG,
  LOAD_EMPLOYER_ANALYTICS_ERROR,
  LOAD_AGENCY_PERFORMANCE_ERROR,
  LOAD_EMPLOYER_PIPELINE_WIDGET,
  LOAD_EMPLOYER_PIPELINE_WIDGET_ERROR,
  LOAD_EMPLOYER_TIME_TO_HIRE_WIDGET,
  LOAD_EMPLOYER_TIME_TO_HIRE_WIDGET_ERROR,
  SELECT_COMPANY_FILTER,
  RESET_COMPANY_FILTER,
  SELECT_DATE_RANGE_FILTER,
  IS_DATE_PICKER_ACTIVE,
  SET_PIPELINE_WIDGET_LOADING,
  SET_TIME_TO_HIRE_WIDGET_LOADING,
  SET_JOBS_PER_SECTOR_WIDGET_LOADING,
  SET_SPEND_PER_SECTOR_WIDGET_LOADING,
  SET_TTH_TIMELINE_WIDGET_LOADING,
  SET_AAT_WIDGET_LOADING,
  SET_PIPELINE_TIMESCALE,
  SET_SPEND_PER_SECTOR_TIMESCALE,
  SET_JOBS_PER_SECTOR_TIMESCALE,
  SET_TTH_TIMELINE_TIMESCALE,
  SET_AAT_TIMESCALE,
  HANDLE_PDF_OPTIONS,
  SELECT_ALL,
  UNSELECT_ALL,
  SELECT_TAB,
  LOAD_EMPLOYER_OFFER_TO_PLACEMENT_WIDGET,
  LOAD_EMPLOYER_OFFER_TO_PLACEMENT_WIDGET_ERROR,
  SET_OFFER_TO_PLACEMENT_WIDGET_LOADING,
  LOAD_EMPLOYER_SPEND_PER_SECTOR_WIDGET,
  LOAD_EMPLOYER_SPEND_PER_SECTOR_WIDGET_ERROR,
  LOAD_EMPLOYER_TOTAL_JOBS_POSTED_WIDGET,
  LOAD_EMPLOYER_TOTAL_JOBS_POSTED_WIDGET_ERROR,
  SET_TOTAL_JOBS_POSTED_WIDGET_LOADING,
  LOAD_EMPLOYER_TOTAL_JOBS_PER_SECTOR_WIDGET,
  LOAD_EMPLOYER_TOTAL_JOBS_PER_SECTOR_WIDGET_ERROR,
  LOAD_EMPLOYER_TIME_TO_HIRE_TIMELINE_WIDGET,
  LOAD_EMPLOYER_TIME_TO_HIRE_TIMELINE_WIDGET_ERROR,
  LOAD_EMPLOYER_APPLICATION_ACTIONS_TRACKING_WIDGET,
  LOAD_EMPLOYER_APPLICATION_ACTIONS_TRACKING_WIDGET_ERROR,
  SET_CURRENTLY_SELECTED_COMPANY,
  RESET_DEFAULT_FILTERS,
  // NEWLY ADDED WIDGETS
} from "../actions/types";

const initialState = {
  loading: true,
  agencyPerformanceLoading: true,
  // Poplify changes analytics
  jobPerformanceLoading: true,
  pslPerformanceLoading: true,
  JobPerformancehasError: false,
  PslPerformancehasError: false,
  // end
  isPremiumOrPortalUser: false,
  isPortalUser: false,
  isPremiumUser: false,
  isRootParentEmployer: false,
  chartsData: {},
  agencyPerformanceData: {
    agencies: [],
    placementSummary: {},
    fillRate: {},
    timeToSubmission: {},
  },
  // Poplify changes analytics
  jobPerformanceData: {},
  pslPerformanceData: {
    pslData: [],
  },
  filtersData: {
    filters: {},
    action: null,
    dispatching: false,
  },
  resetDefaultFilters: {
    isFirstRun: true,
  },
  // end
  companiesList: [],
  selectedCompany: {
    id: null,
    name: null,
  },
  datePickerActive: false,
  selectedDateRange: {
    startDate: null,
    endDate: null,
  },
  pdfExportOptions: {
    allSelected: false,
    options: [
      {
        id: 1,
        value: "pipeline",
        label: "Pipeline",
        isChecked: false,
        type: "employer",
      },
      {
        id: 2,
        value: "timeToHire",
        label: "Time To Hire",
        isChecked: false,
        type: "employer",
      },
      {
        id: 3,
        value: "offerToPlacement",
        label: "Offer To Placement",
        isChecked: false,
        type: "employer",
      },
      {
        id: 4,
        value: "spendPerSector",
        label: "Spend Per Sector",
        isChecked: false,
        type: "employer",
      },
      {
        id: 5,
        value: "totalJobsPosted",
        label: "Total Jobs Posted",
        isChecked: false,
        type: "employer",
      },
      {
        id: 6,
        value: "totalJobsPerSector",
        label: "Total Jobs Per Sector",
        isChecked: false,
        type: "employer",
      },
      {
        id: 7,
        value: "timeToHireTimeline",
        label: "Time To Hire Timeline",
        isChecked: false,
        type: "employer",
      },
      {
        id: 8,
        value: "applicationActionsTracking",
        label: "Recruitment Process Breakdown",
        isChecked: false,
        type: "employer",
      },
      {
        id: 9,
        value: "placementSummary",
        label: "Placement Summary",
        isChecked: false,
        type: "agency",
      },
      {
        id: 10,
        value: "fillRate",
        label: "Fill Rate",
        isChecked: false,
        type: "agency",
      },
      {
        id: 11,
        value: "timeToSubmission",
        label: "Time To Submission",
        isChecked: false,
        type: "agency",
      },
      {
        id: 12,
        value: "leagueTable",
        label: "League Table",
        isChecked: false,
        type: "agency",
      },
    ],
  },
  pipelineWidgetLoader: true,
  timeToHireWidgetLoader: true,
  offerToPlacementWidgetLoader: true,
  spendPerSectorWidgetLoader: true,
  totalJobsPostedWidgetLoader: true,
  totalJobsPerSectorWidgetLoader: true,
  timeToHireTimelineWidgetLoader: true,
  applicationActionsTrackingWidgetLoader: true,
  tabSelected: "",
  errors: {},
  agencyPerformanceErrors: {},
  // new loaders
  candidateSubmissionWidgetLoader: false,
  costSpentOnPlacementsWidgetLoader: false,
  fillRateWidgetLoader: false,
  interviewRateWidgetLoader: false,
  jobSuccessFeeWidgetLoader: false,
  placementRateWidgetLoader: false,
  placementsMadeWidgetLoader: false,
  recruitmentProcessWidgetLoader: false,
  stageProgressionWidgetLoader: false,
  timeToHireWidgetLoader: false,
  timeToSubmissionWidgetLoader: false,
};

export default function employerAnalyticsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_EMPLOYER_ANALYTICS:
      return {
        ...state,
        loading: false,
        agencyPerformanceLoading: true,
        jobPerformanceLoading: true,
        companiesList: payload.companiesList,
        isPremiumOrPortalUser: payload.isPremiumOrPortalUser,
        isPortalUser: payload.isPortalUser,
        isPremiumUser: payload.isPremiumUser,
        isRootParentEmployer: payload.isRootParentEmployer,
        currencySymbol: payload.currencySymbol,
        companyData: payload.companyData,
        errors: {},
      };

    case LOAD_EMPLOYER_PIPELINE_WIDGET:
      return {
        ...state,
        chartsData: {
          ...state.chartsData,
          pipeline: payload,
        },
        pipelineWidgetLoader: false,
      };
    case LOAD_EMPLOYER_PIPELINE_WIDGET_ERROR:
      return {
        ...state,
        pipelineWidgetLoader: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_TIME_TO_HIRE_WIDGET:
      return {
        ...state,
        chartsData: {
          ...state.chartsData,
          timeToHire: payload,
        },
        timeToHireWidgetLoader: false,
      };
    case LOAD_EMPLOYER_TIME_TO_HIRE_WIDGET_ERROR:
      return {
        ...state,
        timeToHireWidgetLoader: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_OFFER_TO_PLACEMENT_WIDGET:
      return {
        ...state,
        chartsData: {
          ...state.chartsData,
          offerToPlacement: payload,
        },
        offerToPlacementWidgetLoader: false,
      };
    case LOAD_EMPLOYER_OFFER_TO_PLACEMENT_WIDGET_ERROR:
      return {
        ...state,
        offerToPlacementWidgetLoader: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_SPEND_PER_SECTOR_WIDGET:
      return {
        ...state,
        chartsData: {
          ...state.chartsData,
          spendPerSector: payload,
        },
        spendPerSectorWidgetLoader: false,
      };
    case LOAD_EMPLOYER_SPEND_PER_SECTOR_WIDGET_ERROR:
      return {
        ...state,
        spendPerSectorWidgetLoader: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_TOTAL_JOBS_POSTED_WIDGET:
      return {
        ...state,
        chartsData: {
          ...state.chartsData,
          totalJobsPosted: payload,
        },
        totalJobsPostedWidgetLoader: false,
      };
    case LOAD_EMPLOYER_TOTAL_JOBS_POSTED_WIDGET_ERROR:
      return {
        ...state,
        totalJobsPostedWidgetLoader: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_TOTAL_JOBS_PER_SECTOR_WIDGET:
      return {
        ...state,
        chartsData: {
          ...state.chartsData,
          totalJobsPerSector: payload,
        },
        totalJobsPerSectorWidgetLoader: false,
      };
    case LOAD_EMPLOYER_TOTAL_JOBS_PER_SECTOR_WIDGET_ERROR:
      return {
        ...state,
        totalJobsPerSectorWidgetLoader: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_TIME_TO_HIRE_TIMELINE_WIDGET:
      return {
        ...state,
        chartsData: {
          ...state.chartsData,
          timeToHireTimeline: payload,
        },
        timeToHireTimelineWidgetLoader: false,
      };
    case LOAD_EMPLOYER_TIME_TO_HIRE_TIMELINE_WIDGET_ERROR:
      return {
        ...state,
        timeToHireTimelineWidgetLoader: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_APPLICATION_ACTIONS_TRACKING_WIDGET:
      return {
        ...state,
        chartsData: {
          ...state.chartsData,
          applicationActionsTracking: payload,
        },
        applicationActionsTrackingWidgetLoader: false,
      };
    case LOAD_EMPLOYER_APPLICATION_ACTIONS_TRACKING_WIDGET_ERROR:
      return {
        ...state,
        applicationActionsTrackingWidgetLoader: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_ANALYTICS_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case LOAD_AGENCY_PERFORMANCE:
      return {
        ...state,
        loading: true,
        isPortalUser: payload.isPortalUser,
        isPremiumUser: payload.isPremiumUser,
        agencyPerformanceLoading: false,
        agencyPerformanceData: payload,
        agencyPerformanceErrors: {},
      };
    case LOAD_JOB_PERFORMANCE:
      return {
        ...state,
        loading: true,
        isPortalUser: payload.isPortalUser,
        isPremiumUser: payload.isPremiumUser,
        jobPerformanceLoading: false,
        pslPerformanceLoading: true,
        jobPerformanceData: payload,
        jobPerformanceErrors: {},
        JobPerformancehasError: false,
        PslPerformancehasError: false,
      };
    case LOAD_JOB_PERFORMANCE_ERROR:
      return {
        ...state,
        loading: false,
        jobPerformanceLoading: false,
        jobPerformanceErrors: payload,
        JobPerformancehasError: true,
        PslPerformancehasError: false,
      };
    case LOAD_PSL_PERFORMANCE:
      return {
        ...state,
        loading: true,
        jobPerformanceLoading: true,
        pslPerformanceLoading: false,
        pslPerformanceData: payload,
        pslPerformanceErrors: {},
        JobPerformancehasError: false,
        PslPerformancehasError: false,
      };
    case LOAD_PSL_PERFORMANCE_ERROR:
      return {
        ...state,
        loading: false,
        pslPerformanceLoading: false,
        pslPerformanceErrors: payload,
        PslPerformancehasError: true,
        JobPerformancehasError: false,
      };
    case RESET_PAGINATION_FLAG:
      return {
        ...state,
        pslPerformanceData: {
          ...state.pslPerformanceData,
          resetPagination: false,
        },
      };
    case RESET_DEFAULT_FILTERS:
      return {
        ...state,
        resetDefaultFilters: payload,
      };
    case EMPLOYER_ANALYTICS_FILTER:
      return {
        ...state,
        filtersData: payload,
        pslPerformanceLoading: payload?.dispatching
          ? true
          : state?.pslPerformanceLoading,
        jobPerformanceLoading: payload?.dispatching
          ? true
          : state?.jobPerformanceLoading,
        filtersLoading: false,
      };
    case LOAD_AGENCY_PERFORMANCE_ERROR:
      return {
        ...state,
        agencyPerformanceLoading: false,
        agencyPerformanceErrors: payload,
      };
    case SET_CURRENTLY_SELECTED_COMPANY:
      return {
        ...state,
        companyData: {
          ...state.companyData,
          ...payload,
        },
      };
    case SELECT_COMPANY_FILTER:
      return {
        ...state,
        selectedCompany: payload,
      };
    case RESET_COMPANY_FILTER:
      return {
        ...state,
        selectedCompany: {
          id: null,
          name: null,
        },
      };
    case RESET_DATE_RANGE_FILTER:
      return {
        ...state,
        selectedDateRange: { startDate: null, endDate: null },
      };
    case SELECT_DATE_RANGE_FILTER:
      return {
        ...state,
        selectedDateRange: payload,
      };
    case IS_DATE_PICKER_ACTIVE:
      return {
        ...state,
        datePickerActive: payload !== null,
      };
    case SET_PIPELINE_WIDGET_LOADING:
      return {
        ...state,
        pipelineWidgetLoader: true,
      };
    case SET_TIME_TO_HIRE_WIDGET_LOADING:
      return {
        ...state,
        timeToHireWidgetLoader: true,
      };
    case SET_OFFER_TO_PLACEMENT_WIDGET_LOADING:
      return {
        ...state,
        offerToPlacementWidgetLoader: true,
      };
    case SET_SPEND_PER_SECTOR_WIDGET_LOADING:
      return {
        ...state,
        spendPerSectorWidgetLoader: true,
      };
    case SET_TOTAL_JOBS_POSTED_WIDGET_LOADING:
      return {
        ...state,
        totalJobsPostedWidgetLoader: true,
      };
    case SET_JOBS_PER_SECTOR_WIDGET_LOADING:
      return {
        ...state,
        totalJobsPerSectorWidgetLoader: true,
      };
    case SET_TTH_TIMELINE_WIDGET_LOADING:
      return {
        ...state,
        timeToHireTimelineWidgetLoader: true,
      };
    case SET_AAT_WIDGET_LOADING:
      return {
        ...state,
        applicationActionsTrackingWidgetLoader: true,
      };
    case SET_PIPELINE_TIMESCALE:
      return {
        ...state,
        pipelineWidgetLoader: false,
        chartsData: {
          ...state.chartsData,
          pipeline: payload,
        },
      };
    case SET_SPEND_PER_SECTOR_TIMESCALE:
      return {
        ...state,
        spendPerSectorWidgetLoader: false,
        chartsData: {
          ...state.chartsData,
          spendPerSector: payload,
        },
      };
    case SET_JOBS_PER_SECTOR_TIMESCALE:
      return {
        ...state,
        totalJobsPerSectorWidgetLoader: false,
        chartsData: {
          ...state.chartsData,
          totalJobsPerSector: payload,
        },
      };
    case SET_TTH_TIMELINE_TIMESCALE:
      return {
        ...state,
        timeToHireTimelineWidgetLoader: false,
        chartsData: {
          ...state.chartsData,
          timeToHireTimeline: {
            ...state.chartsData.timeToHireTimeline,
            ...payload,
          },
        },
      };
    case SET_AAT_TIMESCALE:
      return {
        ...state,
        applicationActionsTrackingWidgetLoader: false,
        chartsData: {
          ...state.chartsData,
          applicationActionsTracking: {
            ...state.chartsData.applicationActionsTracking,
            ...payload,
          },
        },
      };
    case HANDLE_PDF_OPTIONS:
      return {
        ...state,
        pdfExportOptions: {
          options: state.pdfExportOptions.options.map((option) => {
            if (option.value === payload) {
              return {
                ...option,
                isChecked: !option.isChecked,
              };
            }
            return option;
          }),
          allSelected: state.pdfExportOptions.allSelected,
        },
      };
    case SELECT_ALL:
      return {
        ...state,
        pdfExportOptions: {
          options: state.pdfExportOptions.options.map((option) => ({
            ...option,
            isChecked: option.type === payload && true,
          })),
          allSelected: true,
        },
      };
    case UNSELECT_ALL:
      return {
        ...state,
        pdfExportOptions: {
          options: state.pdfExportOptions.options.map((option) => ({
            ...option,
            isChecked: false,
          })),
          allSelected: false,
        },
      };
    case SELECT_TAB:
      return {
        ...state,
        pdfExportOptions: {
          ...state.pdfExportOptions,
          allSelected: false,
        },
        tabSelected: payload,
      };
    default:
      return state;
  }
}
